import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
    const auth = useSelector((state) => state.auth);
    const isAuthenticated = auth?.token || localStorage.getItem('token');

    return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
